"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasPlaceholder = void 0;
const video_client_core_1 = require("@video/video-client-core");
const active_placeholder_1 = require("./active-placeholder");
class CanvasPlaceholder extends video_client_core_1.ObservableEventEmitter {
    static isSupported() {
        return (document.createElement("canvas") != null &&
            video_client_core_1.adapter.device.supportsMediaStreamCapture(document.createElement("canvas")));
    }
    constructor(options) {
        super();
        this.canvasInterval = null;
        this.element = null;
        this.options = options !== null && options !== void 0 ? options : active_placeholder_1.defaultOptions;
        this.addInnerDisposer(() => {
            this.stop();
        });
    }
    async start() {
        this.stop();
        this.element = document.createElement("canvas");
        this.element.setAttribute("width", `${this.options.width}px`);
        this.element.setAttribute("height", `${this.options.height}px`);
        const context = this.element.getContext("2d");
        const canvasWidth = this.element.width;
        const canvasHeight = this.element.height;
        function drawCanvas() {
            if (context != null) {
                context.clearRect(0, 0, canvasWidth, canvasHeight);
                // color in the background
                if (context != null) {
                    context.fillStyle = "black";
                }
                context.fillRect(0, 0, canvasWidth, canvasHeight);
                context.fill();
            }
        }
        this.canvasInterval = setInterval(drawCanvas, 1000);
    }
    stop() {
        if (this.canvasInterval != null) {
            clearInterval(this.canvasInterval);
            this.canvasInterval = null;
            this.element = null;
        }
    }
}
exports.CanvasPlaceholder = CanvasPlaceholder;
//# sourceMappingURL=canvas-placeholder.js.map